import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import Modal from '@tds/community-modal';

import PropTypes from 'prop-types';
import { HeaderButton } from './css';
import { useLocaleActionsContext } from '../context/LocaleContext';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import request from '../utils/request';
import Help from '../help';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';

import { localeEn, localeFr, getPathVariables } from '../misc';

const Menu = ({ locale, userRights }) => {
  const history = useHistory();
  const setLocale = useLocaleActionsContext();
  const localizedStrings = useLocalizedStringsContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [showHelpSection, setShowHelpSection] = useState(false);

  const config = {
    ...contentfulFormConfig,
    content_type: 'header',
    locale
  };
  const [helpLink, setHelpLink] = useState('');
  const {
    headerLinks: {
      home,
      help,
      labelEnglish,
      labelFrench,
      labelLogout,
      labelLogDefect
    },
    switchLocaleModal: {
      modalTitle,
      modalBody,
      modalConfirmButtonLabel,
      modalCancelButtonLabel
    }
  } = localizedStrings;

  const onClickLogout = () => {
    request
      .get('/orders/unlock')
      .then(() => {
        localStorage.clear();
        history.push('/');
        window.location.reload();
      })
      .catch(err => {
        console.log(err);
      });
  };

  const changeLocale = () => {
    setLocale(locale === localeEn ? localeFr : localeEn);
  };

  const shouldSwitchLocale = () => {
    const [, path] = getPathVariables(history.location.pathname);
    if (path) setModalOpen(true);
    else changeLocale();
  };

  const onConfirm = () => {
    setModalOpen(false);
    changeLocale();
    history.push('/');
  };

  const onCloseModal = () => setModalOpen(false);

  useEffect(() => {
    getContentfulData(config)
      .then(res => {
        const headerData = getData(res);
        const link = _.get(headerData, 'helpPdf.fields.file.url', '');
        setHelpLink(link);
      })
      .catch(() => {});
  }, [locale]);

  const focusElementOnClose = useRef(null);

  return (
    <>
      {userRights && (
        <>
          {userRights.isHomeLinkVisible && (
            <li>
              <div>
                <Link variant="link" to="/">
                  {home}
                </Link>
              </div>
            </li>
          )}
          <li>
            <div>
              <HeaderButton onClick={() => setShowHelpSection(true)}>
                {help}
              </HeaderButton>
            </div>
          </li>
          <li>
            <div>
              <Link variant="link" to="/report-an-issue">
                {labelLogDefect}
              </Link>
            </div>
          </li>
          <li>
            <div>
              <HeaderButton onClick={shouldSwitchLocale}>
                {locale === localeEn ? labelFrench : labelEnglish}
              </HeaderButton>
            </div>
          </li>
          <li>
            <div>
              <HeaderButton onClick={onClickLogout}>{labelLogout}</HeaderButton>
            </div>
          </li>
        </>
      )}
      <Modal
        heading={modalTitle}
        bodyText={modalBody}
        confirmCTAText={modalConfirmButtonLabel}
        cancelCTAText={modalCancelButtonLabel}
        onConfirm={onConfirm}
        onClose={onCloseModal}
        isOpen={isModalOpen}
        focusElementAfterClose={focusElementOnClose}
      />
      {showHelpSection && (
        <Help guideLink={helpLink} setShowHelpSection={setShowHelpSection} />
      )}
    </>
  );
};

Menu.propTypes = {
  locale: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isQuoteApprovalDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHomeLinkVisible: PropTypes.bool
  }).isRequired
};

export default Menu;
